import { mapProjectToBackendPayload } from "./backendPayload";

export function buildSaveInteractionsPayload(project, achievementVideoId) {
  const backend = mapProjectToBackendPayload(project);

  const interactions = backend.Interactions.map((interaction) => ({
    Interaction: JSON.stringify(interaction),
    VideoInteractionType: interaction.type,
    StartTime: Math.round(interaction.StartTimeSec * 1000)
  }));



  return {
    AchievementVideoId: achievementVideoId,
    VideoInteractions: interactions
  };
}
